@if (decimalDirective) {
  @if (!showViewMode) {
    <div [formGroup]="form" [ngClass]="{'inverted': invertedColor}"
      class="component-wrapper">
      <div class="label-wrapper">
        @if (label) {
          <label
            [for]="HTML_ID"
            [ngClass]="{'small': isSmallLabel}">
            <span [attr.data-cy]="labelCypressTag">{{label}}</span>
          </label>
        }
        @if (hasWarningStar) {
          <app-warning-star
            [attr.data-cy]="warningStarCypressTag"
          [type]="warningLevel"></app-warning-star>
        }
        <div [attr.data-cy]="labelInformationCypressTag" class="label-information">
          <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
        </div>
      </div>
      <div [ngClass]="{'invalid': !isValid, 'focus': isFocused, 'disabled': isDisabled, 'alternate-background': alternateBackground}"
        [ngStyle]="{'width': width}"
        class="input-wrapper">
        <app-tooltip [disable]="inputHasEllipsis" [dynamic]="false" [message]="tooltipText">
          <input decimalNumbersOnly
            (blur)="inputBlur.emit($event)"
            (click)="inputClick.emit($event)"
            (focus)="inputFocus.emit($event)"
            (keydown)="inputKeyDown.emit($event)"
            (mouseenter)="toggleTooltip($event)"
            [attr.data-cy]="textInputCypressTag"
            [formControlName]="FORM_CONTROL_NAME"
            [id]="HTML_ID"
            [maxlength]="maxLength ? maxLength : null"
            [ngStyle]="inputHeight"
            [placeholder]="placeholder"
            class="text-ellipsis input"
            type="text">
        </app-tooltip>
        @if (hasIconButton()) {
          <div class="icon-wrapper">
            @if (hasDeleteButton) {
              <button (click)="deleteInputValue()"
                [attr.data-cy]="deleteButtonCypressTag"
                class="input-button">
                <span [class]="deleteButtonIconClass"></span>
              </button>
            }
          </div>
        }
        @if (units && units.length > 0) {
          <div
            [attr.data-cy]="unitsInputCypressTag"
          class="input-units">{{units}}</div>
        }
      </div>
      @if (showMessages) {
        @for (message of messages | anyKeyValue; track message) {
          @if (message.value.length > 0) {
            <app-warning-inline
              [warningInlineLabelsArray]="message.value"
            [warningType]="message.key"></app-warning-inline>
          }
        }
      }
    </div>
  } @else {
    <div [ngClass]="{'inverted': invertedColor}" class="component-view-wrapper">
      <div class="label-wrapper">
        @if (label) {
          <label
            [ngClass]="{'small': isSmallLabel}">
            <span [attr.data-cy]="labelCypressTag">{{label}}</span>
          </label>
        }
      </div>
      <div [attr.data-cy]="inputWrapperCypressTag" class="input-wrapper view-mode">
        <span [attr.data-cy]="inputValueCypressTag">{{initialValue}}</span>
      </div>
    </div>
  }
} @else {
  @if (!showViewMode) {
    <div [formGroup]="form" [ngClass]="{'inverted': invertedColor}"
      class="component-wrapper">
      <div class="label-wrapper">
        @if (label) {
          <label
            [for]="HTML_ID"
            [ngClass]="{'small': isSmallLabel}">
            <span [attr.data-cy]="labelCypressTag">{{label}}</span>
          </label>
        }
        @if (hasWarningStar) {
          <app-warning-star
            [attr.data-cy]="warningStarCypressTag"
          [type]="warningLevel"></app-warning-star>
        }
        <div [attr.data-cy]="labelInformationCypressTag" class="label-information">
          <ng-container *ngTemplateOutlet="labelInformation"></ng-container>
        </div>
      </div>
      <div [ngClass]="{'invalid': !isValid, 'focus': isFocused, 'disabled': isDisabled, 'alternate-background': alternateBackground}"
        [ngStyle]="{'width': width}"
        class="input-wrapper">
        <app-tooltip [disable]="inputHasEllipsis" [dynamic]="false" [message]="tooltipText">
          <input (blur)="inputBlur.emit($event)"
            (click)="inputClick.emit($event)"
            (focus)="inputFocus.emit($event)"
            (keydown)="inputKeyDown.emit($event)"
            (mouseenter)="toggleTooltip($event)"
            [attr.data-cy]="textInputCypressTag"
            [formControlName]="FORM_CONTROL_NAME"
            [id]="HTML_ID"
            [maxlength]="maxLength ? maxLength : null"
            [ngStyle]="inputHeight"
            [placeholder]="placeholder"
            class="text-ellipsis input"
            type="text">
        </app-tooltip>
        @if (hasIconButton()) {
          <div class="icon-wrapper">
            @if (hasDeleteButton) {
              <button (click)="deleteInputValue()"
                [attr.data-cy]="deleteButtonCypressTag"
                class="input-button">
                <span [class]="deleteButtonIconClass"></span>
              </button>
            }
          </div>
        }
        @if (units && units.length > 0) {
          <div
            [attr.data-cy]="unitsInputCypressTag"
          class="input-units">{{units}}</div>
        }
      </div>
      @if (showMessages) {
        @for (message of messages | anyKeyValue; track message) {
          @if (message.value.length > 0) {
            <app-warning-inline
              [warningInlineLabelsArray]="message.value"
            [warningType]="message.key"></app-warning-inline>
          }
        }
      }
    </div>
  } @else {
    <div [ngClass]="{'inverted': invertedColor}" class="component-view-wrapper">
      <div class="label-wrapper">
        @if (label) {
          <label
            [ngClass]="{'small': isSmallLabel}">
            <span [attr.data-cy]="labelCypressTag">{{label}}</span>
          </label>
        }
      </div>
      <div [attr.data-cy]="inputWrapperCypressTag" class="input-wrapper view-mode">
        <span [attr.data-cy]="inputValueCypressTag">{{initialValue}}</span>
      </div>
    </div>
  }
}


